import { ISystemApiV1, RolesList } from "@connect/Interfaces";
import { GET } from "Api/V1/CRUD";

export default class SystemApi implements ISystemApiV1 {
	getRolesList() {
		return GET("/system/acl/roles?nofilter", true) as Promise<RolesList>;
	}
}